export default "__VITE_ASSET__CVSILn3d__"